















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import coupon from "./coupon.vue";
import { Swiper } from "swiper";

@Component({
  components: {
    coupon,
  },
})
export default class CouponLayout3 extends Mixins(Mixin) {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public couponList!: cms.SubjectCouponInfoDto[];

  mounted() {
    new Swiper(".swiper", {
      slidesPerView: "auto",
    });
  }
  receive(item: cms.SubjectCouponInfoDto) {
    this.$emit("receive", item);
  }
}
